export const GenderValues = Object.freeze([
    "женский",
    "мужской",
    "средний",
    "общий"
]);

export const Gender = Object.freeze({
    "FEMININE": GenderValues[0],
    "MASCULINE": GenderValues[1],
    "NEUTER": GenderValues[2],
    "COMMON": GenderValues[3]
});

export const FEM = 1;
export const MASC = 2;
export const NEU = 3;
export const COM = 4;
